import { SYNC_KEY_PROYECTOS_TECNICOS } from "../../../constantes";
import { ProyectosPlataformaService, TecnicoProyectoItem } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { TecnicoResponse, TecnicoStatsResponse } from "../../../shared/response/proyectos/TecnicoResponse";
import { ServiceGetListBase } from "../../../shared/services/base/ServiceGetListBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";

/** Técnicos de campo (`ProyectosPlataformaService`, gRPC): listado en memoria + stats. */
export class TecnicoService extends ServiceGetListBase<TecnicoResponse> {
  static readonly instance = new TecnicoService();
  private constructor() { super(); }

  /** Clave única del listado: deduplica `sync()` (dos pedidos simultáneos, un solo request). */
  protected readonly syncKey = SYNC_KEY_PROYECTOS_TECNICOS;

  /** gRPC-Web (`ListTecnicos`): no eliminados, por nombre. */
  protected async fetchItems(): Promise<TecnicoResponse[]> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).listTecnicos({}));
    return r.items.map(toTecnicoResponse);
  }

  /** Totales para los KPIs (`GetTecnicosStats`). */
  async getStats(): Promise<TecnicoStatsResponse> {
    const s = await grpcCall(() => grpcClient(ProyectosPlataformaService).getTecnicosStats({}));
    return {
      totalTecnicos: s.totalTecnicos,
      activos: s.activos,
      totalProyectos: s.totalProyectos,
      promedioPorTecnico: s.promedioPorTecnico,
      totalHa: s.totalHa,
    };
  }
}

/** Mensaje gRPC del técnico → `TecnicoResponse`. Lo reusa el guardado. */
export function toTecnicoResponse(t: TecnicoProyectoItem): TecnicoResponse {
  return {
    id: t.id,
    isEliminado: false,
    nombre: t.nombre,
    email: t.email,
    telefono: t.telefono ?? "",
    zona: t.zona,
    isActivo: t.isActivo,
    usuarioPlataformaId: t.usuarioPlataformaId ?? null,
    totalProyectos: t.totalProyectos,
    totalHa: t.totalHa,
    createdAt: Number(t.createdAt),
    enlazadoAUsuarioExistente: t.enlazadoAUsuarioExistente,
  };
}
